import React from "react";
import { useParams } from "react-router-dom";
import Page from "../Components/Page";
import ControlDetails from "../features/controls/details/ControlDetails";
import useFetchData from "../hooks/useFetchData";
import { IControl } from "../features/controls/types";

export default function ControlPage() {
  const params = useParams();
  const { data: control, isLoading } = useFetchData<IControl>(
    `/controls/${params.controlid}`,
  );
  return (
    <Page isLoading={isLoading}>
      {control && <ControlDetails control={control} />}
    </Page>
  );
}
